<template>
  <ProductListDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :popup-width="'1000px'"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
  >
    <!-- <el-form ref="query" :inline="true" :model="query">
      <el-form-item label="商品编号" prop="skuCode">
        <el-input v-model="query.skuCode" placeholder="商品编号"></el-input>
      </el-form-item>
      <el-form-item label="商品名称" prop="skuName">
        <el-input v-model="query.skuName" placeholder="商品名称"></el-input>
      </el-form-item>
      <eui-btn type="primary" @click="handleSearch">查询</eui-btn>
      <eui-btn type="primary" @click="handleClear">重置</eui-btn>
      <eui-btn type="primary" @click="exportFile">导出</eui-btn>
    </el-form> -->
    <e-search
      :data="query"
      :field-list="filterInfo.fieldList"
      class="margin-b20"
      @handleFilter="handleSearch"
      @handleReset="handleClear"
      @handleFocus="focusClassify"
    ></e-search>
    <eui-btn type="primary" class="margin-b20" @click="exportFile">导出</eui-btn>
    <TableList
      :table-data="tableData"
      :table-label="tableLabel"
      :loading="loading"
      :selection-show="multipleSelection"
      max-height="240"
    >
      <template #pic="slot">
        <img :src="slot.scope.row.defaultImage" style="width: 48px; height: 48px" />
      </template>
      <template #confirmStatus="slot">
        {{ formatConfirmStatus(slot.scope.row.confirmStatus) }}
      </template>
      <template #rate="slot">
        {{ slot.scope.row.price ? (slot.scope.row.agreementPrice ? formatRate(slot.scope.row) : '') : '-' }}
      </template>
    </TableList>

    <div class="pagination">
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="productTagPage.currentPage"
        :page-size="productTagPage.pageSize"
        :total="productTagPage.pageTotal"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 所属分类 -->
    <ClassifyTree
      v-if="classifyVisible"
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></ClassifyTree>
  </ProductListDialog>
</template>

<script>
import ESearch from '@/modules/projectA/components/common/e-search';
import ProductListDialog from '../../../../../components/common/epecDialog';
import TableList from '../../common/e-table-list';
import agreementApi from '../../../api/agreement/index';
import utils from '../../../utils/utils';
import ClassifyTree from './classifyTree';

export default {
  name: 'ProductDialog',
  components: {
    ProductListDialog,
    TableList,
    ClassifyTree,
    ESearch,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userIdentity: {
      type: Number,
      default: 0,
    },
    agreementId: {
      type: Number,
      required: true,
      default: 0,
    },
    supplierCompanyId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '图片',
          param: 'defaultImage',
          align: 'center',
          slot: 'pic',
        },
        {
          label: '商品名称',
          param: 'skuName',
          align: 'center',
        },
        {
          label: '商品编号',
          param: 'skuCode',
          align: 'center',
        },
        {
          label: '类目名称',
          param: 'categoryName',
          align: 'center',
        },
        {
          label: '计量单位',
          param: 'unitValue',
          align: 'center',
        },
        {
          label: '协议价(元)',
          param: 'agreementPrice',
          align: 'center',
        },
        {
          label: '市场价(元)',
          param: 'price',
          align: 'center',
        },
        {
          label: '优惠比例',
          param: 'rate',
          align: 'center',
          slot: 'rate',
        },
        {
          label: '确认状态',
          param: 'confirmStatus',
          align: 'center',
          slot: 'confirmStatus',
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      query: {
        skuCode: '',
        skuName: '',
        categoryIdList: [],
        categoryName: '',
      },
      dialogTitle: '商品清单',
      multipleSelection: false,

      classifyVisible: false,
      defaultCheckedKeys: [],
      categoryTreeData: [],
      filterInfo: {
        /* data: {
          skuCode: null,
          skuName: null,
          brandName: null,
          categoryName: null,
        }, */
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode', width: '180' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '类目名称',
            type: 'dialog',
            value: 'categoryName',
            placeholder: '支持多选',
          },
        ],
      },
      categoryIds: [],
    };
  },
  computed: {},
  created() {
    this.getMdmTypeListNoPage();
  },
  methods: {
    async getMdmTypeListNoPage() {
      const params = {
        agreementId: this.agreementId,
      };

      const res = await agreementApi.getMdmTypeList(params);
      if (res.data) {
        for (let i = 0; i < res.data.length; i++) {
          this.categoryIds.push(res.data[i].categoryId);
        }

        this.query.categoryIdList = this.categoryIds;

        this.getProductPriceList();
      }
    },
    // 获取分类树数据
    async getAllCategoryTree() {
      const res = await agreementApi.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.agreementId,
      });
      if (res.code === '200') {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.getAllCategoryTree();
      if (this.query.categoryIdList?.length) {
        this.defaultCheckedKeys = this.query.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      console.log(this.query, '11111');
      if (val?.length === 0) {
        this.query.categoryIdList = this.categoryIds;
        this.classifyVisible = false;
        return;
      }
      const filterNode = [];
      val.forEach((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.query.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.query.categoryName = arr.join('、');
      this.classifyVisible = false;

      console.log(this.query, '2222');
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
    async exportFile() {
      const params = this.formatParams();
      const res = await agreementApi.downAgreementPrice(params);
      console.log(res, '120');
      if (res.size !== 0) {
        utils.downFile(res, `AgreementPrices`);
      }
    },
    handleSearch(val) {
      console.log(val);
      this.query = { ...this.query, ...val };
      console.log(this.query);
      this.productTagPage.currentPage = 1;
      this.getProductPriceList();
    },
    handleClear() {
      this.query.skuName = '';
      this.query.skuCode = '';
      this.query.categoryIdList = [];
      this.query.categoryName = '';
      this.getProductPriceList();
    },
    handleSizeChange(val) {
      this.productTagPage.pageSize = val;
      this.productTagPage.currentPage = 1;
      this.getProductPriceList();
    },
    handleCurrentChange(val) {
      this.productTagPage.currentPage = val;
      this.getProductPriceList();
    },
    updateVisible() {},
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {
      this.$emit('close');
    },
    getProductPriceList() {
      const params = this.formatParams();
      agreementApi.getProductList(params).then((res) => {
        if (res.data) {
          this.tableData = res.data.records;
          this.productTagPage.pageTotal = res.data.total;
        }
      });
    },
    formatParams() {
      const res = {};
      res.pageNum = this.productTagPage.currentPage;
      res.pageSize = this.productTagPage.pageSize;
      res.agreementId = this.agreementId;
      res.skuName = this.query.skuName;
      res.skuCode = this.query.skuCode;
      res.categoryIdList = this.query.categoryIdList;
      res.userIdentity = this.userIdentity === 2 ? 'purchase' : '';
      res.supplierCompanyId = this.supplierCompanyId;
      return res;
    },
    formatConfirmStatus(val) {
      let res = '';
      switch (val) {
        case 0:
          res = '未提交';
          break;
        case 1:
          res = '待确认';
          break;
        case 2:
          res = '已确认';
          break;
        case 3:
          res = '拒绝';
          break;
        case 4:
          res = '已停用';
          break;
        default:
          res = '';
          break;
      }
      return res;
    },
    formatRate(val) {
      return `${(((val.price - val.agreementPrice) / val.price) * 100).toFixed(2)}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
